export interface EnvironmentConfig {
  name: string;
  apiEndpoint: string;
  cognitoUserPoolId: string;
  cognitoClientId: string;
  cognitoDomain: string;
}

export const environments: Record<string, EnvironmentConfig> = {
  production: {
    name: 'Production',
    apiEndpoint: process.env.REACT_APP_PROD_API_ENDPOINT || '',
    cognitoUserPoolId: process.env.REACT_APP_PROD_USER_POOL_ID || '',
    cognitoClientId: process.env.REACT_APP_PROD_CLIENT_ID || '',
    cognitoDomain: process.env.REACT_APP_PROD_COGNITO_DOMAIN || '',
  },
  staging: {
    name: 'Staging',
    apiEndpoint: process.env.REACT_APP_STAGING_API_ENDPOINT || '',
    cognitoUserPoolId: process.env.REACT_APP_STAGING_USER_POOL_ID || '',
    cognitoClientId: process.env.REACT_APP_STAGING_CLIENT_ID || '',
    cognitoDomain: process.env.REACT_APP_STAGING_COGNITO_DOMAIN || '',
  },
  development: {
    name: 'Development',
    apiEndpoint: process.env.REACT_APP_DEV_API_ENDPOINT || '',
    cognitoUserPoolId: process.env.REACT_APP_DEV_USER_POOL_ID || '',
    cognitoClientId: process.env.REACT_APP_DEV_CLIENT_ID || '',
    cognitoDomain: process.env.REACT_APP_DEV_COGNITO_DOMAIN || '',
  },
};

export const AWS_REGION = process.env.REACT_APP_AWS_REGION || 'us-east-1';